import { Component } from "@angular/core";

@Component({
  selector: 'enrichment-pathway',
  templateUrl: './enrichment-pathway.component.html',
  styleUrls: ['./enrichment-pathway.component.scss']
})
export class EnrichmentPathwayComponent {
}
